import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../utils/translations';
import { usePreferences } from '../context/PreferencesContext';
import './Navbar.css';

function Navbar({ user, onLogout }) {
  const location = useLocation();
  const { preferences } = usePreferences();
  const t = useTranslation(preferences.language);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link 
          to="/" 
          className="navbar-logo"
          onClick={() => {
            window.location.reload();
            closeMenu();
          }}
        >
          <div className="navbar-logo-container">
            <img 
              src="/rbr.ico" 
              alt="Rate by Recommendation Logo" 
              className="navbar-logo-icon"
            />
            <h1 className="navbar-title">Rate by Recommendation</h1>
          </div>
        </Link>
        
        {user && (
          <>
            <button
              className="navbar-toggle"
              onClick={toggleMenu}
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <span className={`navbar-toggle-icon ${isMenuOpen ? 'open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
            <div className={`navbar-menu ${isMenuOpen ? 'open' : ''}`}>
              <Link 
                to="/" 
                className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                🏠 {t('home')}
              </Link>
              <Link 
                to="/watchlist" 
                className={`navbar-link ${location.pathname === '/watchlist' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                📋 {t('watchlist')}
              </Link>
              <Link 
                to="/my-ratings" 
                className={`navbar-link ${location.pathname === '/my-ratings' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                ⭐ {t('myRatings')}
              </Link>
              <Link 
                to="/recommendations" 
                className={`navbar-link ${location.pathname === '/recommendations' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                🎯 {t('recommendations')}
              </Link>
              <Link 
                to="/circles" 
                className={`navbar-link ${location.pathname === '/circles' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                👥 {t('circles')}
              </Link>
              <Link 
                to="/profile" 
                className={`navbar-link ${location.pathname === '/profile' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                👤 {t('profile')}
              </Link>
            </div>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;

